import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';
import { Input } from '~/components/Form';
import { number } from '~/helpers';

import { ContainerForm } from './styles';

import { GFO, GFO_CONSULTA } from '~/constants/perfil';

export default function MyForm({ data, reference, close }) {

  const { profile } = useSelector((state) => state.user);



  async function handleSubmit(param) {
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>

        <div className="Container__grupos">

          <p> DADOS DA NOTA FISCAL:</p>
          <div className="Container__nf_dados">
            <Input
              name="desc_num_pedido"
              label="Pedido"
              disabled
              value={data.desc_num_pedido}
            />

            <Input
              name="prod_display"
              label="Combustível"
              disabled
              value={data.prod_display}
            />

            <Input
              name="desc_nf"
              label="Nota Fiscal"
              disabled
              value={data.desc_nf}
            />

            <Input
              name="desc_distribuidora"
              label="Distribuidora"
              disabled
              value={data.desc_distribuidora}
            />

            <Input
              name="desc_dt_emissao_nf"
              label="Emissão NF"
              disabled

              value={moment(data.desc_dt_emissao_nf).format('DD/MM/YYYY HH:mm:ss')}
            />

            <Input
              name="desc_transportadora"
              label="Transportadora"
              disabled
              value={data.desc_transportadora}
            />

            {/* //export function number(value = 0.0, options = '0')  */}


            <Input
              name="desc_volume_nf"
              label="Volume"
              disabled
              value={number(data.desc_volume_nf, 2)}
            />

            <Input
              name="desc_placa_ct"
              label="Placa CT"
              disabled
              value={data.desc_placa_ct}
            />


            <Input
              name="desc_preco_unitario"
              label="Preço Unit."
              disabled
              value={number(data.desc_preco_unitario, 4)}
            />

            <Input
              name="desc_motorista"
              label="Motorista"
              disabled
              value={data.desc_motorista}
            />

            <Input
              name="desc_valor_total"
              label="Valor Total"
              disabled
              value={number(data.desc_valor_total, 2)}
            />


            <Input
              name="nfre_destinat_nome"
              label="Órgão"
              disabled
              value={data.orga_nome}
            />

            <Input
              name="desc_data_inicio"
              label="Data Início"
              disabled
              value={moment(data.desc_data_inicio).format('DD/MM/YYYY HH:mm:ss')}
            />


            <Input
              name="desc_data_fim"
              label="Data Fim"
              disabled
              //value={moment(data.desc_data_fim).format('DD/MM/YYYY HH:mm:ss')}
              value={ data.desc_data_fim !== null ?  moment(data.desc_data_fim).format('DD/MM/YYYY HH:mm:ss') : '-'}
              

            />
          </div>

          <p>DADOS DA UNIDADE RECEPTORA DO PRODUTO:</p>
          <div className="Container__nf_busca">
            <Input
              name="nfre_destinat_nome"
              label="Órgão"
              disabled
              value={data.orga_nome}
            />

            <Input
              name="poco_descricao"
              label="Posto"
              disabled
              value={data.poco_descricao}
            />
          </div>


          {(profile.gloperfilid !== GFO) ?
            (profile.gloperfilid !== GFO_CONSULTA) ? 
            <>
              <p>TANQUES RECEPTORES</p>
              <div className="Container__nf_dados_grade">

                <SimpleTable

                  url="recebimentotanque"
                  cells={[
                    {
                      id: 'tafi_nome',
                      label: 'Tanque:',
                    },
                    {
                      id: 'deta_volume_inicial',
                      label: 'Vol.Inicial (L):',
                      align: 'right',
                      format: (value) => number(value, 2),
                    },
                    {
                      id: 'deta_volume_final',
                      label: 'Vol.Final (L)',
                      align: 'right',
                      format: (value) => number(value, 2),
                    },

                    {
                      id: 'deta_auxrecebido',
                      label: 'Vol.Medido (L)',
                      align: 'right',
                      format: (value) => number(value, 2),
                    },
                    {
                      id: 'tafi_auxespvazio',
                      label: 'Espaço Tanque (L)',
                       align: 'right',
                      format: (value) => number(value, 2),
                    },
                  ]}
                  unique={['tafi_codigo']}
                  form={MyForm}
                  onCreate={false}
                  onUpdate={false}
                  onDelete={false}
                  title={'Tanques Receptores'}
                  restProps={''}
                  query={{
                    wherefield: ['desc_codigo'],
                    valuewherefield: [data.desc_codigo],
                    typewherefield: ['EQUALS'],
                  }}
                />
              </div>

              <p>RESUMO DO RECEBIMENTO</p>
              <div className="Container__nf_dados_resumo">
                <Input
                  name="resumonf"
                  label="Volume NF"
                  size="small"
                  margin="dense"
                  value={number(data.desc_volume_nf, 1)}
                  disabled
                />

                <Input
                  name="resumovolumerecebido"
                  label="Volume recebido"
                  size="small"
                  margin="dense"
                  value={number(data.desc_volume_recebido, 1)}
                  disabled
                />

                <Input
                  name="resumonfdiferenca"
                  label="Diferença"
                  size="small"
                  margin="dense"
                  value={number(data.desc_volume_recebido - data.desc_volume_nf, 1)}
                  disabled
                />
              </div>
            </>
            : ''
            : ''
          }
        </div>
      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
